import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CrewDetailView } from '@/components/CrewDetailView'

const crewDetailSearchSchema = z.object({
  tab: z.enum(['overview', 'documents', 'flights']).optional().default('overview'),
})

export const Route = createFileRoute('/_auth/crew/$crewId')({
  component: RouteComponent,
  validateSearch: crewDetailSearchSchema,
})

function RouteComponent() {
  const { crewId } = Route.useParams()
  const { tab } = Route.useSearch()

  return <CrewDetailView crewId={crewId} initialTab={tab} publicView />
}
